import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

/**
 * Small spinning/loading icon suitable for use in buttons
 * @param {string} color - The color of the spinner (default: currentColor)
 * @param {number} size - Size in pixels (default: 16)
 */
export default function SpinningIcon({ color = "currentColor", size = 16 }) {
  return (
    <svg
      className={styles.spinner}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="2"
        strokeDasharray="15.7 62.8"
        opacity="0.7"
      />
    </svg>
  );
}

SpinningIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};
